import { useContentType } from '@confluence/page-context';
import {
	ContentType,
	isCanvasContentType,
} from '@confluence/content-types-utils/entry-points/contentTypeConstants.ts';

export const useIsNewDanglingCommentExperienceEnabled = (): boolean => {
	const [contentType] = useContentType();

	return contentType !== ContentType.DATABASE && !isCanvasContentType(contentType);
};
